import React from 'react'
import type { FC } from 'react'
import cn from 'classnames'
import Link from 'next/link'

import { BsChevronRight } from 'react-icons/bs'
import Text from './ui/text'
import { Career } from '@telesoft/types/payload-types'

interface VacancyProps {
  vacancy: Career
  className?: string
  contactClassName?: string
  imageContentClassName?: string
  variant?: 'grid' | 'gridSlim' | 'list' | 'listSmall'
  imgWidth?: number | string
  imgHeight?: number | string
  imgLoading?: 'eager' | 'lazy'
}

const VacancyCard: FC<VacancyProps> = ({
  vacancy,
  className = '',
  contactClassName = '',
  variant = 'list',
}) => {
  return (
    <Link
      href={{
        pathname: `/vacancy/${vacancy.slug}`,
        query: { slug: vacancy.slug },
      }}
    >
      <button
        className={cn(
          'text-heading border-heading group box-border flex h-full cursor-pointer border-b ',
          {
            'w-full flex-col items-start justify-items-stretch bg-white pe-0 transition duration-200 ease-in-out':
              variant === 'grid',
            'flex-col items-start bg-white pe-0': variant === 'gridSlim',
            'transform items-start border border-gray-100 bg-transparent transition duration-200 ease-in-out':
              variant === 'listSmall',
            'hover:border-telesoft flex-row items-start py-8 pe-2 transition-transform ease-linear lg:pe-3 2xl:pe-4':
              variant === 'list',
          },
          className,
        )}
        title={vacancy?.title}
      >
        <div
          className={cn(
            'mb-4 w-full',
            {
              'pe-2.5 ps-0 transition-all duration-300 xl:pe-4': variant === 'grid',
              'ps-0': variant === 'gridSlim',
              'px-4 lg:px-5 2xl:px-4': variant === 'listSmall',
            },
            contactClassName,
          )}
        >
          <Text variant="heading" className="mb-4 text-left">
            {vacancy?.title}
          </Text>
          {vacancy?.summary && (
            <Text className="text-body max-w-[90%] text-left text-xs leading-normal lg:text-sm xl:leading-relaxed">
              {vacancy?.summary && vacancy.summary.length > 128
                ? vacancy.summary.substring(0, 128) + '...'
                : vacancy.summary}
            </Text>
          )}
        </div>

        <div className="flex items-center">
          <BsChevronRight
            size="18"
            className="text-heading block text-sm transition duration-300 group-hover:translate-x-2 xl:block"
          />
        </div>
      </button>
    </Link>
  )
}

export default VacancyCard
